export default __webpack_public_path__ + "static/media/Sora-Bold.5255f50b.ttf";